import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type { GetBlogItemResT } from 'server/controllers/blog';
import type * as SSBlogServiceM from 'server/services/blog/get';

import { type BlogItemT, P_API_BLOG } from 'utils';

const ss = webpack.requireWeak<typeof SSBlogServiceM>('server/services/blog', import.meta.dirname);

export async function getBlogItem(id: string): Promise<BlogItemT> {
  if (ss) {
    const res = await ss.getBlogItem(id);
    if (!res) throw Error('Not found');

    return res;
  }

  const res = await axios<GetBlogItemResT>(`${P_API_BLOG}/${id}`);

  return res.data;
}
